import { useQuery } from '@tanstack/react-query';
import { queryKeys } from '@/lib/queryKeys';
import { transfersShippingLogsService } from '@/services/transfers-shipping';

export const useTransfersShippingLogs = () => {
  return useQuery({
    queryKey: queryKeys.transfersShipping.logs(),
    queryFn: () => transfersShippingLogsService.listLogs(),
    staleTime: 30_000,
  });
};
